import { render, staticRenderFns } from "./Revenues.vue?vue&type=template&id=18911281&scoped=true&"
import script from "./Revenues.vue?vue&type=script&lang=js&"
export * from "./Revenues.vue?vue&type=script&lang=js&"
import style0 from "./Revenues.vue?vue&type=style&index=0&id=18911281&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18911281",
  null
  
)

export default component.exports